import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useGetTasksQuery } from "../../../features/tasks/taskAPI";
import Task from "./Task";

function TaskList() {
  const { data, isLoading, isError, isSuccess } = useGetTasksQuery();

  const [displayData, setDisplayData] = useState([]);
  const { projects, searchTerm } = useSelector((state) => state.filter);

  useEffect(() => {
    if (isSuccess) {
      let showData = [...data];
      const showProjects = projects
        ?.filter((project) => project.isChecked)
        ?.map((project) => project?.id);

      showData = showData?.filter((entry) =>
        showProjects.includes(entry?.project.id)
      );

      if (searchTerm) {
        showData = showData?.filter((entry) =>
          entry.taskName?.toLowerCase().includes(searchTerm?.toLowerCase())
        );
      }

      setDisplayData(showData);
    }
  }, [data, projects, searchTerm, isSuccess]);

  let content = null;

  if (isLoading) content = "Loading....";
  if (!isLoading && isError) content = "Something Went Wrong!";
  if (!isLoading && !isError && displayData?.length === 0)
    content = "No Task yet...";
  if (!isLoading && !isError && displayData?.length > 0)
    content = displayData?.map((task) => <Task task={task} key={task?.id} />);

  return <div className="lws-task-list">{content}</div>;
}

export default TaskList;
